<template>
  <div class="HCropper">
    <vueCropper
      ref="cropper"
      :img="option.img"
      :outputSize="option.size"
      :outputType="option.outputType"
      :info="true"
      :full="option.full"
      :canMove="option.canMove"
      :canScale="option.canScale"
      :canMoveBox="option.canMoveBox"
      :original="option.original"
      :autoCrop="option.autoCrop"
      :fixed="option.fixed"
      :fixedNumber="option.fixedNumber"
      :centerBox="option.centerBox"
      :infoTrue="option.infoTrue"
      :fixedBox="option.fixedBox"
      :mode="option.mode"
      @realTime="realTime"
    ></vueCropper>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  useSlots,
  ref,
  watchEffect,
} from "vue";
import util from "@util/js";
export default defineComponent({
  name: "HCropper",
  components: {},
  props: {
    imgUrl: {
      type: String,
      defalut: "",
    },
    //开始截图后是否直接获取截图照片，false状态需要先判断再调取结束截图方法
    overBool: {
      type: Boolean,
      defalut: true,
    },
    //上传图片就返回整张图片  false 等待截取后在返回
    autoBack: {
      type: Boolean,
      defalut: true,
    },
    //点击图片获取整体。
    clickBack: {
      type: Boolean,
      defalut: true,
    },
    //图片是否能移动
    canMove: {
      type: Boolean,
      defalut: true,
    },
    //图片是否能移动
    mode: {
      type: String,
      defalut: "",
    },
  },
  setup(props, context) {
    const cropper = ref(null);
    const state = reactive({
      option: {
        img: "", // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: "jpeg", // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: false, // 是否默认生成截图框
        // autoCropWidth: 300, // 默认生成截图框宽度
        // autoCropHeight: 200, // 默认生成截图框高度
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: false, // 是否开启截图框宽高固定比例
        fixedNumber: [7, 5], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        canMove: true, // 不能拖动图片
        mode: "cover", // 图片渲染方式

        // maxImgSize: 10, // 不能拖动图片
      },
      emitImgAxiss: true,
    });
    const refData = toRefs(state);
    watchEffect(() => {
      state.option.img = props.imgUrl;
      state.option.canMove = props.canMove;
      if (props.mode) state.option.mode = props.mode;
    });
    const slotTitle = !!useSlots().title;
    const realTime = (data) => {
      if (!props.autoBack) return;
      finish();
      getImgAxiss();
    };
    const finish = () => {
      cropper.value.getCropData((data) => {
        state.img = data;
        context.emit("imgFinish", data);
        console.log(cropper.value, data);
      });
    };
    const getImgAxiss = () => {
      if (!state.emitImgAxiss) return;
      const data = cropper.value.getCropAxis();
      context.emit("getImgAxiss", data);
    };

    const startCrop = () => {
      cropper.value.startCrop();
      // if (!props.clickBack) return;
      state.emitImgAxiss = true;
      getImgAxiss();
      finish();
    };

    const stopCrop = () => {
      state.emitImgAxiss = false;
      cropper.value.stopCrop();
      cropper.value.clearCrop();
    };
    const cropEnd = () => {
      cropper.value.stopCrop();
    };

    return {
      ...refData,
      slotTitle,
      realTime,
      finish,
      cropper,
      startCrop,
      stopCrop,
      cropEnd,
      getImgAxiss,
    };
  },
});
</script>
<style lang="scss" scoped>
.HCropper {
  height: 100%;
  width: 100%;
  .vue-cropper {
    // width: 100%;
    // height: 200px;
    background: #fff !important;
    // /deep/.cropper-box-canvas {
    //   width: 100% !important;
    //   height: 100% !important;
    //   transform: none !important;
    //   img {
    //     width: 100% !important;
    //     height: 100% !important;
    //   }
    // }
    // /deep/.cropper-view-box {
    //   width: 100% !important;
    //   height: 100% !important;
    //   transform: none !important;
    //   img {
    //     width: 100% !important;
    //     height: 100% !important;
    //   }
    // }
  }
}
</style>
